// most of this is copied from MUI docs for BasicMenu and then slightly modified

import * as React from 'react';
import { getAuth } from 'firebase/auth';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';

const auth = getAuth();

const AccountMenuLink = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      auth.signOut();
      // window.location = '/' as any; // redirect to home upon logout
    } catch (error: any) {
      const errorCode = error.code;
      const errorMessage = error.message;
    }
  };

  const userEmail = auth.currentUser?.email || '';

  return (
    <>
      <div
        className="accountMenuLink"
        title="Account Menu"
        onClick={handleClick}
      >
        <AccountCircleIcon className="accountIcon"/>
      </div>
      <Menu
        className="accountMenu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
      >
        <MenuItem disableRipple disableTouchRipple style={{ cursor: 'default' }} className="accountEmail">
          {userEmail}
        </MenuItem>
        <MenuItem onClick={() => {
          // go to profile
          navigate('/account');
          handleClose();
        }}>Account Settings</MenuItem>

        <MenuItem onClick={() => {
          handleLogout();
          handleClose();
        }}>Log Out</MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenuLink;